





































































import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class Footer extends Vue {
  get years() {
    return [2017, new Date().getFullYear()].join(" - ");
  }
}
